import {Component, Input, OnDestroy} from '@angular/core';
import {ChatbotIcons, ChatbotMsg} from './interfaces/library.interface';
import {filter, fromEvent, Subscription} from 'rxjs';
import {ChatbotIconComponent} from './components/chatbot-icon.component';
import {ChatbotTextboxComponent} from './components/chatbox-text/chatbot-text.component';
import {StorageService} from '../../../core/service';


@Component({
    selector: 'chatbot',
    imports: [ChatbotIconComponent, ChatbotTextboxComponent],
    template: `
    @if (!showTextBox) {
      <chatbot-icon [iconChatbot]="icons.chatbotIcon"
                    (chatbotClicked)="onChatbotClicked()">
      </chatbot-icon>
    } @else {
      <chatbot-textbox [icons]="icons"
                       titleText="Myarp@ Chatbot"
                       [welcomeMessage]="welcomeMessage"
                       [errorMessage]="errorMessage"
                       [chatbotStorageKey]="chatbotStorageKey"
                       (closeChatbot)="onCloseChatbot($event)">
      </chatbot-textbox>
    }
	`
})
export class ChatbotComponent implements OnDestroy {

	@Input({required: true}) icons!: ChatbotIcons;
	@Input({required: true}) welcomeMessage: string;
	@Input({required: true}) errorMessage: string;
	@Input({required: true}) chatbotStorageKey: string;

	showTextBox = false;

	readonly keyDownEvent$ = fromEvent<KeyboardEvent>(document, 'keydown');
	private keyInputSub !: Subscription;

	constructor(private storage: StorageService) {
	}

	ngOnDestroy(): void {
		if (this.keyInputSub) {
			this.keyInputSub.unsubscribe();
		}
	}

	//Method called whenever the chatbot icon is clicked
	onChatbotClicked(): void {
		this.showTextBox = true;
		this._subscribeToKeydownEvent();
	}

	onCloseChatbot(listOfMessages: ChatbotMsg[]): void {
		this.showTextBox = false;
		this.storage.setItemLocal(this.chatbotStorageKey, JSON.stringify(listOfMessages));
	}

	private _subscribeToKeydownEvent(): void {
		this.keyInputSub = this.keyDownEvent$.pipe(filter(event => event.key === 'Escape')).subscribe(() => {
			this.showTextBox = false;
			this.keyInputSub.unsubscribe();
		});
	}

}
